import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { i18n } from '@/i18n';
import { TableContentItem } from '../../interface/tableContentItems';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { useEditIndividualBusinessStore } from '@/editBusinessModule/pages/useEditIndividualBusinessStore';
import { storeToRefs } from 'pinia';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditBusinessButton',
  props: {
    item: {}
  },
  setup(__props: any) {

const props = __props;

const t = i18n.t;

const store = useEditIndividualBusinessStore();
const { state } = storeToRefs(store);

/**
 * ボタンクリック時の処理
 */
const onClick = () => {
  store.setEditingBusiness(props.item);
  store.openEditModal();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TextButton, {
    "button-style": "btn-secondary",
    onClick: onClick
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('編集')), 1)
    ], undefined, true),
    _: 1
  }))
}
}

})